import script from "./condimentsBasic.vue?vue&type=script&lang=ts&setup=true"
export * from "./condimentsBasic.vue?vue&type=script&lang=ts&setup=true"

import "./condimentsBasic.vue?vue&type=style&index=0&id=a17a8530&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a17a8530"]])

export default __exports__